import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import accounting from 'accounting';
import ReactHighcharts from 'react-highcharts';
import highchartsMore from 'highcharts/highcharts-more';
import solidGauge from 'highcharts/modules/solid-gauge';
import { each, capitalize } from 'lodash';
import { getIsFontSizeBig } from '../../../App/AppReducer';

import styles from './opportunity-graphs.css';
import { getColorFromKey } from '../../../../util/helpers';
import Legend from './legend';
import { format as formatMoney } from '../../../../components/money-display';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';

if (typeof window !== 'undefined') {
  highchartsMore(ReactHighcharts.Highcharts);
  solidGauge(ReactHighcharts.Highcharts);
}

class Pie extends Component {
  render() {
    const {
      bucket, reportType, animated, type, hasNoDecisionSetup, organization, subTitle, title,
      isFontSizeBig,
    } = this.props;
    if (!bucket) {
      return null;
    }
    const titleTotal = bucket.grandTotal !== undefined ? accounting.formatNumber(bucket.grandTotal, 0) : accounting.formatNumber(bucket.total, 0);

    // const amountTotal = accounting.formatMoney(bucket.amount, '$', 0);
    let suffix = '';
    let symbol = '';
    if (organization) {
      suffix = organization.currency_suffix;
      symbol = organization.currency_symbol;
    }

    const data = [];
    each(bucket.stats, (stat, key) => {
      let t = 'unknown';
      const color = getColorFromKey(key);
      const sf = `deal${(stat.total !== 1 ? 's' : '')}`;
      const total = accounting.formatNumber(stat.total, 0);
      const amount = formatMoney(stat.amount, true, 1, symbol, suffix);
      let { unit } = stat;
      unit = capitalize(unit);
      if (!unit) {
        if (key === 'won') {
          unit = 'Won';
        } else if (key === 'lost') {
          unit = 'Lost';
        } else if (key === 'noDecision') {
          unit = 'No Decision';
        }
      }
      if (reportType === 'amount') {
        if (key === 'won') {
          t = `${unit}: ${total} ${sf}`;
        } else if (key === 'lost') {
          t = `${unit}: ${total} ${sf}`;
        } else if (key === 'noDecision') {
          t = `${unit} Decision: ${total} ${sf}`;
        }
      } else if (key === 'won') {
        t = `${unit}: ${amount}`;
      } else if (key === 'lost') {
        t = `${unit}: ${amount}`;
      } else if (key === 'noDecision') {
        t = `${unit} Decision: ${amount}`;
      }
      data.push({
        name: t,
        y: reportType === 'count' ? stat.total : stat.amount,
        color,
        amount: stat.amount,
        total: stat.total,
        opportunityIds: stat.opportunityIds,
        select: false,
        events: {
          click: (event) => {
            this.props.onChartSegmentSelect(event.point.options.opportunityIds);
          },
        },
      });
    });

    const subSize = '18px';

    const config = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        backgroundColor: 'rgba(0, 0, 0, 0)',
        type: 'pie',
      },
      credits: {
        enabled: false,
      },
      title: {
        text: `${titleTotal}<br /><small style="font-size: ${subSize};">${title}</small>`,
        verticalAlign: 'middle',
        y: 5,
        style: {
          color: '#333333',
          fontSize: '70px',
          fontWeight: '700',
        },
      },
      subtitle: {
        text: subTitle,
        verticalAlign: 'middle',
        y: 45,
        style: {
          color: 'rgba(0, 0, 0, 0.75)',
          fontSize: '14px',
        },
      },
      tooltip: {
        formatter: function format() {
          const percentage = accounting.formatNumber(this.percentage, 2);
          const k = this.key;
          const c = accounting.formatNumber(this.y, 0);
          let amount = null;

          if (reportType === 'amount') {
            amount = formatMoney(this.point.amount, true, 1, symbol, suffix);
          } else {
            amount = `${accounting.formatNumber(c, 0)} deals`;
          }
          return `<div style="color:${this.color}"><p>${k}</p><b>${amount}</b> (${percentage}%)</div>`;
        },
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        borderColor: 'rgba(0, 0, 0, 0.25)',
        useHTML: true,
        style: {
          color: 'rgba(255, 255, 255, 0.75)',
          fontSize: isFontSizeBig ? '16px' : null,
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          shadow: false,
          borderWidth: 0,
          animation: animated ? {
            duration: 1000,
          } : false,
          dataLabels: {
            enabled: false,
          },
        },
      },
      pane: {
        startAngle: 0,
        endAngle: 360,
        background: [
          {
            outerRadius: '100%',
            innerRadius: '95%',
            backgroundColor: 'rgba(255,255,255,.5)',
            borderWidth: 0,
          },
        ],
      },
      series: [{
        name: title,
        colorByPoint: true,
        innerSize: '95%',
        data,
      }],
    };
    const pieCls = animated ? 'animated bounceIn' : '';
    const legendCls = animated ? 'animated fadeIn' : '';
    const legendLightCls = '';
    return (
      <div>
        <div className={`${styles[`pie-${type}`]} ${pieCls}`}>
          <div className={styles.graphWrapper}>
            <ReactHighcharts config={config} ref={`chart-${type}`} />
          </div>
        </div>
        <div className={`${styles[`legend-${type}`]} ${legendCls} ${legendLightCls}`}>
          <Legend
            bucket={bucket}
            reportType={reportType}
            onChartSegmentSelect={this.props.onChartSegmentSelect}
            hasNoDecisionSetup={hasNoDecisionSetup}
          />
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
    isFontSizeBig: getIsFontSizeBig(state),
  };
}
Pie.propTypes = {
  bucket: PropTypes.shape({}).isRequired,
  animated: PropTypes.bool,
  hasNoDecisionSetup: PropTypes.bool,
  reportType: PropTypes.string.isRequired,
  organization: PropTypes.shape({}),
  subTitle: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string.isRequired,
  onChartSegmentSelect: PropTypes.func,
  isFontSizeBig: PropTypes.bool.isRequired,
};
Pie.defaultProps = {
  hasNoDecisionSetup: false,
  organization: null,
  animated: true,
  subTitle: '',
  title: '',
  onChartSegmentSelect: () => {},
};
export default connect(mapStateToProps)(Pie);
